<template>
    <div class="ml">
        <LogoTextH style="width: 6rem" />
        <h1 class="text-small text-uppercase my-0">Manual de Marca</h1>
    </div>
</template>

<script>
    import LogoTextH from './LogoTextH';

    export default {
        name: 'BrandBookLogoText',
        components: { LogoTextH },
    };
</script>
